import { Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function CheckIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Path d="M5 12.5l4.5 4.5L19 7.5" />
    </LineIcon>
  );
}
